import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useProjects } from '../hooks/useProjects';
export function ProjectsGallery() {
  const {
    projects: allProjects
  } = useProjects();
  // Mostrar solo los proyectos destacados
  const featuredProjects = allProjects.filter(p => p.featured).slice(0, 3);
  // Si no hay destacados, mostrar los 3 más recientes como fallback
  const projectsToShow = featuredProjects.length > 0 ? featuredProjects : allProjects.slice(0, 3);
  return <section className="bg-gray-50 py-16 sm:py-24 lg:py-32" data-id="element-243">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="mb-12 sm:mb-16 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end" data-id="element-245">
          <div data-id="element-246">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900" data-id="element-247">
              Proyectos Recientes
            </h2>
            <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-500" data-id="element-248">
              Calidad, orden y detalle en cada ejecución.
            </p>
          </div>
          <Link to="/proyectos" className="rounded-full border border-gray-300 px-6 py-2 font-semibold text-gray-600 transition-colors hover:border-blue-600 hover:text-blue-600 text-sm sm:text-base" data-id="element-249">
            Ver todos los proyectos
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-250">
          {projectsToShow.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`group relative aspect-[4/3] overflow-hidden rounded-2xl sm:rounded-3xl bg-gray-200 shadow-md ${index > 0 ? 'hidden sm:block' : ''}`} data-id="element-251">
              <img src={project.image} alt={project.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-252" />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-253" />
              <div className="absolute bottom-0 left-0 p-6 translate-y-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100" data-id="element-254">
                <span className="mb-2 inline-block rounded-full bg-blue-600 px-3 py-1 text-xs font-bold text-white" data-id="element-255">
                  {project.category}
                </span>
                <p className="text-lg font-bold text-white" data-id="element-256">{project.name}</p>
                <div className="mt-2 flex gap-3 text-white/80 text-xs" data-id="element-257">
                  <span data-id="element-258">{project.year}</span>
                  <span data-id="element-259">•</span>
                  <span data-id="element-260">{project.m2} m²</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}